import { Store, createEvent, sample } from 'effector';

const createStorage = <T extends object>($store: Store<T>) => {
    const cleanSetFx = createEvent<T>();

    sample({ clock: cleanSetFx, target: $store });

    function setF(setter: (store: T) => T): void {
        cleanSetFx(setter($store.getState()));
    }

    return {
        set: setF,
    };
};

export default createStorage;
